export default __webpack_public_path__ + "static/media/mastercard.5733928f.svg";